import React, { useState } from "react";
import ActionSection from "../components/ActionSection";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      id: 1,
      question: "Koliko traje efekat puder obrva?",
      answer:
        "Efekat traje od 1 do 2 godine, u zavisnosti od tipa kože, načina nege i životnih navika klijenta.",
    },
    {
      id: 2,
      question: "Da li je tretman bolan?",
      answer:
        "Ne, tretman je minimalno bolan jer se koristi anestetik u obliku kreme, što ga čini veoma podnošljivim.",
    },
    {
      id: 3,
      question: "Da li se puder obrve rade na svim tipovima kože?",
      answer:
        "Da, ali kod masne kože pigment može brže da izbledi, pa su potrebni češći dodaci boje (osvežavanje).",
    },
    {
      id: 4,
      question: "Kome se ne preporučuje tretman puder obrva?",
      answer:
        "Tretman puder obrva nije preporučljiv za:\n<ul><li>Trudnice i dojilje</li><li>Osobe sa dijabetesom tipa 1</li><li>Osobe sa kožnim oboljenjima u predelu obrva</li><li>One koji koriste lekove za razređivanje krvi</li><li>Onkološke pacijente</li><li>Osobe koje su nedavno imale hemijski piling ili laserski tretman</li><li>Osobe sklone hipertrofičnim ožiljcima</li><li>One koji koriste određene lekove, poput Roaccutane-a</li></ul> Ako niste sigurni da li ste kandidat za tretman, najbolje je da se posavetujete sa vašim lekarom pre donošenja odluke.",
    },
    {
      id: 5,
      question: "Kako izgleda postupak iscrtavanja puder obrva?",
      answer:
        "Proces uključuje konsultaciju, gde se uzima u obzir anatomija lica i želje klijenta, zatim oblikovanje obrva, izbor boje pigmenta i samu pigmentaciju, koja traje oko 2 sata.",
    },
    {
      id: 6,
      question: "Koliko traje oporavak nakon tretmana?",
      answer:
        "Prvih nekoliko dana obrve će biti tamnije, a zatim će postepeno posvetleti. Površinsko zarastanje traje oko 7 do 14 dana, dok se pigment potpuno stabilizuje i dobije svoju konačnu nijansu nakon otprilike mesec dana.",
    },
    {
      id: 7,
      question: "Kada je potrebno raditi korekciju?",
      answer:
        "Prva korekcija se radi 4-6 nedelja nakon prvog tretmana, a osvežavanje boje preporučuje se na 12-18 meseci.",
    },
    {
      id: 8,
      question: "Kako da negujem obrve nakon tretmana?",
      answer:
        "<ul><li>Izbegavati sunce, saunu i bazene</li><li>Ne skidati krastice rukama</li><li>Nanositi preporučenu kremu za zarastanje</li></ul>",
    },
    {
      id: 9,
      question: "Šta ako ne budem zadovoljna rezultatom?",
      answer:
        "Pigment vremenom bledi, a obaveznom korekcijom se može poboljšati izgled. Takođe postoji mogućnost uklanjanja lasera ili sredstvima za uklanjanje pigmenta.",
    },
    {
      id: 10,
      question: "Da li puder obrve menjaju boju tokom vremena?",
      answer:
        "Pri pravilnom radu i korišćenju kvalitetnog pigmenta, obrve vremenom samo postaju svetlije, bez promene u neželjene tonove poput crvene ili sive.",
    },
    {
      id: 11,
      question: "Kako izgleda proces zarastanja?",
      answer:
        "Prvih nekoliko dana obrve su tamnije, zatim dolazi do ljuštenja, a finalna boja se stabilizuje za 4 do 6 nedelja.",
    },
    {
      id: 12,
      question:
        "Da li mogu da se rade puder obrve ako imam stare iscrtane obrve?",
      answer:
        "Ako je pigment dovoljno izbledeo, može se raditi tretman. Ako su obrve tamne, možda će biti potrebno uklanjanje starog pigmenta.",
    },
    {
      id: 13,
      question: "Kako da izaberem pravu boju pigmenta?",
      answer:
        "Boja pigmenta se bira prema tonu kože, boji prirodnih obrva i boji kose. Stručnjak će preporučiti odgovarajuću nijansu.",
    },
    {
      id: 14,
      question: "Da li mogu nositi šminku nakon tretmana?",
      answer:
        "Šminkanje je dozvoljeno ali treba izbegavati područje obrva dok traje proces zarastanja (oko 7-10 dana). Jedini izuzetak je prvi dan nakon tretmana, kada se ne preporučuje nanošenje šminke na lice.",
    },
    {
      id: 15,
      question: "Da li mogu da vežbam i znojim se nakon tretmana?",
      answer:
        "Ne, treba izbegavati znojenje prvih 7-10 dana jer znoj može izbaciti pigment iz kože.",
    },
    {
      id: 16,
      question: "Da li mogu ići na sunčanje posle tretmana?",
      answer:
        "Sunce može izbledeti pigment, zato je preporučljivo izbegavati direktno sunce i solarijum bar mesec dana nakon tretmana.",
    },
    {
      id: 17,
      question: "Da li nudite konsultacije pre tretmana?",
      answer:
        "Da, pre tretmana se obavlja besplatna konsultacija kako bismo zajedno pronašli idealan oblik i boju za vaše obrve.",
    },
    {
      id: 18,
      question: "Da li mogu dobiti probno iscrtavanje pre tretmana?",
      answer:
        "Da, oblik obrva se prvo iscrtava olovkom kako biste videli kako će izgledati pre nego što počne tretman.",
    },
    {
      id: 19,
      question: "Šta ako imam alergijsku reakciju na pigment?",
      answer:
        "Pre tretmana možemo uraditi test na koži kako bismo bili sigurni da nema alergijskih reakcija.",
    },
    {
      id: 20,
      question: "Kako da se pripremim za tretman?",
      answer:
        "<ul><li>Ne konzumirati alkohol 24h pre tretmana</li><li>Ne koristiti retinol i kiselinske preparate u oblasti obrva</li><li>Ne raditi botoks ili hemijski piling u predelu obrva 2-3 nedelje pre tretmana</li></ul>",
    },
    {
      id: 21,
      question: "Da li mogu raditi puder obrve ako imam ožiljke na obrvama?",
      answer:
        "Da, ali pigment se može drugačije primiti na ožiljcima. Potrebno je individualno proceniti mogućnosti tretmana.",
    },
    {
      id: 22,
      question:
        "Koje su prednosti puder obrva u odnosu na klasično šminkanje obrva?",
      answer:
        "<ul><li>Dugotrajan efekat</li><li>Štedi vreme na svakodnevnom šminkanju</li><li>Prirodan izgled</li><li>Otpornost na vodu, znoj i brisanje</li></ul>",
    },
  ];

  return (
    <>
      <div className="container banner">
        <div className="wrapper p-30">
          <div className="title-box">
            <h1 className="title">
              Puder Obrve - Najčešća Pitanja i Odgovori (FAQ)
            </h1>
            <h2 className="subtitle">
              Sve što trebate znati o tehnici puder obrva
            </h2>
          </div>
        </div>
      </div>

      <div>
        <div className="wrapper faq p-30">
          <div className="faq-text w-1000">
            {faqData.map((item, index) => (
              <div className="gues_box" key={index}>
                <div>
                  <div
                    data-aos="fade-left"
                    className="ques"
                    onClick={() => toggleQuestion(index)}
                  >
                    <div className="ques_text">
                      <div className="id_ques">{item.id}</div>
                      <p>{item.question}</p>
                    </div>
                    <span>&#9660;</span>
                  </div>

                  {openIndex === index && (
                    <p
                      data-aos="fade-left"
                      className={`ans_text ${
                        openIndex === index ? "open" : ""
                      }`}
                      dangerouslySetInnerHTML={{ __html: item.answer }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div data-aos="zoom-in">
        <ActionSection />
      </div>
    </>
  );
}
